import { render } from "./CreatePage.vue?vue&type=template&id=d8bd5336&scoped=true"
import script from "./CreatePage.vue?vue&type=script&lang=js"
export * from "./CreatePage.vue?vue&type=script&lang=js"

import "./CreatePage.vue?vue&type=style&index=0&id=d8bd5336&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8bd5336"]])

export default __exports__